import { LivestreamProvider, livestreamStore } from '../../ng-services/livestreams/livestream.store';

export class StartLivestreamButtonComponent {
    livestreamProvider!: LivestreamProvider;

    onClick() {
        if (this.isWatchingLivestream) {
            livestreamStore.stop();
            return;
        }

        if (this.livestreamProvider.recent_livestream && this.hasLivestream) {
            livestreamStore.start(this.livestreamProvider.recent_livestream);
        }
    }

    get hasLivestream() {
        return this.livestreamProvider?.recent_livestream?.status === 'live';
    }

    get isWatchingLivestream() {
        return livestreamStore.isWatchingLivestream;
    }
}

angular.module('tradersyard').component('tyStartLivestreamButton', {
    // language=HTML
    template: `
        <button class="btn btn-wide btn-success" ng-disabled="$ctrl.isWatchingLivestream" ng-if="$ctrl.hasLivestream" ng-click="$ctrl.onClick()">
            <span ng-if="!$ctrl.isWatchingLivestream"><i class="fa fa-play"></i> Watch Live stream</span>
            <span ng-if="$ctrl.isWatchingLivestream" disabled><i class="fa fa-play"></i> Live stream is playing</span>
        </button>
    `,
    controller: StartLivestreamButtonComponent,
    bindings: {
        livestreamProvider: '<',
    },
});
